﻿function changeManufacturer() {
    window.location = $("#ManufacturerId").val();
}

export function setupCarsLandingPage() {
    $(document).on("click", "[data-cars-landing-page]", changeManufacturer);
}